import { ApiManager } from '../../core/api-manager';
import { DataManager } from '../../core/data-manager';
import { settings } from '../../config/settings';
import { LanguageProvider } from '../../core/language-provider';
import { toast } from 'react-toastify';



export async function preUpdate(entity, data, id) {

    var d = { ...data }

    if (entity === 'sample') {
        d.sample1 = 'test'
    }
    else if (entity === "customer") {
        console.log('customer pre insert data', data)
        var res = await DataManager.getItem('payment_condition', parseInt(data.idPaymentCondition));
        var resCE = await DataManager.getItem('country', parseInt(data.idCountry));
        var resInc = await DataManager.getItem('incoterms', parseInt(data.idIncoterms));


        if (resCE.success === 1) {

            if (resCE.body[0].areaGeoObbligatorio === 1 && (data.idAreaGeografica === "" || data.idAreaGeografica === null)) {
                toast.error("Geografia (statistiche) è obbligatoria per questo stato.", { theme: 'colored' })
                return {
                    success: 0,
                    data: d,
                    message: ''
                }
            }
        }
        if (data.offices && data.offices.length === 0) {
            toast.error("Inserire almeno un indirizzo di consegna.", { theme: 'colored' })
            return {
                success: 0,
                data: d,
                message: ''
            }
        }
        else {
            return {
                success: 1,
                data: d,
                message: ''
            }
        }
        if (resInc.body[0].internalDelivery === 1 && !data.idSpedizione) {
            toast.error("Tariffa di spedizione obbligatoria per questo Incoterms.", { theme: 'colored' })
            return {
                success: 0,
                data: d,
                message: ''
            }
        }
    }
    else if (entity === "item_model") {
        console.warn('---AAA--', data)
        if (data.suppliers && data.suppliers.length > 0) {
            const activeItems = data.suppliers.filter(item => item.active === 1);
            if (activeItems.length === 0) {
                toast.error("Non c'é nessun listino fornitore attivo.", { theme: 'colored' })
                return {
                    success: 0,
                    data: d,
                    message: "Non c'é nessun listino fornitore attivo."
                }
            } else if (activeItems.length > 1) {
                toast.error("Ci sono più listino fornitori attivi per questo articolo.", { theme: 'colored' })
                return {
                    success: 0,
                    data: d,
                    message: "Ci sono più listino fornitori attivi per questo articolo."
                }
            }
        }
    }
    else if (entity === "supplier_order") {
        console.log(data)
        if (data.typeOrder !== "5_MATERIA_PRIMA" && data.idWarehouseStart === null) {
            toast.error("Il magazzino di partenza è obbligatorio per questo tipo ordine", { theme: 'colored' })
            return {
                success: 0,
                data: d,
                message: ''
            }
        }
        if ((data.typeOrder === "0_CONTO_LAVORO" || data.typeOrder === "15_RIPRISTINO") && (data.idForwarder === null || data.scope === null || data.weight === "" || data.itemsAspect === "")) {
            toast.error("Vettore, Causale, Peso e Aspetto beni sono obbligatori per questo tipo di ordine.", { theme: 'colored' })
            return {
                success: 0,
                data: d,
                message: ''
            }
        }
        if (data.rows && data.rows.length > 0) {
            for (let i = 0; i < data.rows.length; i++) {
                if (data.rows[i].idItemModelSupplier === "" || data.rows[i].idItemModelSupplier === null) {
                    toast.error("Listino fornitore non presente nella riga.", { theme: 'colored' })
                    return {
                        success: 0,
                        data: d,
                        message: ''
                    }
                }
                if (data.rows[i].price === "" || data.rows[i].price === null) {
                    toast.error("Prezzo non presente nella riga.", { theme: 'colored' })
                    return {
                        success: 0,
                        data: d,
                        message: ''
                    }
                }
            }
        }


    }
    else if (entity === "supplier_offer") {
        console.log(data)
        if (data.typeOffer !== "5_MATERIA_PRIMA" && data.idWarehouseStart === null) {
            toast.error("Il magazzino di partenza è obbligatorio per questo tipo ordine", { theme: 'colored' })
            return {
                success: 0,
                data: d,
                message: ''
            }
        }
        if (data.typeOffer === "0_CONTO_LAVORO" && (data.idForwarder === null || data.scope === null || data.weight === "" || data.itemsAspect === "")) {
            toast.error("Vettore, Causale, Peso e Aspetto beni sono obbligatori per questo tipo di ordine.", { theme: 'colored' })
            return {
                success: 0,
                data: d,
                message: ''
            }
        }
        if (data.rows && data.rows.length > 0) {
            for (let i = 0; i < data.rows.length; i++) {
                if (data.rows[i].idItemModelSupplier === "" || data.rows[i].idItemModelSupplier === null) {
                    toast.error("Listino fornitore non presente nella riga.", { theme: 'colored' })
                    return {
                        success: 0,
                        data: d,
                        message: ''
                    }
                }
                if (data.rows[i].price === "" || data.rows[i].price === null) {
                    toast.error("Prezzo non presente nella riga.", { theme: 'colored' })
                    return {
                        success: 0,
                        data: d,
                        message: ''
                    }
                }
            }
        }


    }
    else if (entity === "customer_order") {
        console.log(data)

        if (data && data.idCustomer) {
            var res = await DataManager.getItem('customer', data.idCustomer);
            if (res.success === 1) {
                const c = res.body[0]
                console.log(res.body)
                if (c.idCountry) {
                    if (parseInt(c.category.value) !== 0) {
                        if (c.idCountry.codiceISO === "IT") {
                            if (c.sdi === "" || c.vatNumber === "") {
                                toast.error("SDI e Partita IVA devono essere presenti per questo cliente.", { theme: 'colored' })
                                return {
                                    success: 0,
                                    data: d,
                                    message: ''
                                }
                            }
                        }
                        if (c.idCountry.isUE === 1 && c.idCountry.codiceISO !== "IT") {
                            if (c.vatNumber === "") {
                                toast.error("Partita IVA deve essere presente per questo cliente.", { theme: 'colored' })
                                return {
                                    success: 0,
                                    data: d,
                                    message: ''
                                }
                            }
                        }
                        if (c.idCountry.isUE === 0) {
                            //niente di obbligatorio
                        }
                    } else {
                        if (c.idCountry.codiceISO === "IT") {
                            if (c.taxCode === "") {
                                toast.error("Codice fiscale deve essere presente per questo cliente.", { theme: 'colored' })
                                return {
                                    success: 0,
                                    data: d,
                                    message: ''
                                }
                            }
                        }
                    }
                }
            }
        }


        if (data && data.idIncoterms) {
            var res = await DataManager.getItem('incoterms', data.idIncoterms);
            console.log(res)
            if (res.success === 1) {
                if (res.body[0].internalDelivery !== 0 && !data.address) {
                    toast.error("L'indirizzo di consegna è obbligatorio in quanto la spedizione non è a carico del cliente.", { theme: 'colored' })
                    return {
                        success: 0,
                        data: d,
                        message: ''
                    }
                }
                if (res.body[0].internalDelivery !== 0 && !data.idSpedizione) {
                    toast.error("La tariffa di spedizione è obbligatoria.", { theme: 'colored' })
                    return {
                        success: 0,
                        data: d,
                        message: ''
                    }
                }
            }
        }
    }
    else if (entity === "customer_offer") {
        console.log(data)
        if (data && data.idIncoterms) {
            var res = await DataManager.getItem('incoterms', data.idIncoterms);
            console.log(res)
            if (res.success === 1) {
                if (res.body[0].internalDelivery !== 0) {
                    if (data && data.address === null) {
                        toast.error("L'indirizzo di consegna è obbligatorio in quanto la spedizione non è a carico del cliente.", { theme: 'colored' })
                        return {
                            success: 0,
                            data: d,
                            message: ''
                        }
                    }

                }
                if (res.body[0].internalDelivery !== 0 && !data.idSpedizione) {
                    toast.error("La tariffa di spedizione è obbligatoria.", { theme: 'colored' })
                    return {
                        success: 0,
                        data: d,
                        message: ''
                    }
                }
            }
        }
    }

    return {
        success: 1,
        data: d,
        message: ''
    }
}